import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import companyCardService from '../../../services/companyCardService'
import { CompanyCard } from '@leadgen/models/client'

class CompanyCardsActions {
  loadCompanyCards = createAsyncThunk(
    'companyCards/loadCompanyCards',
    async ({ companyId }: { companyId: string }, { dispatch }) => {
      const response = await companyCardService.subscribeToCompanyCards({
        companyId,
        onCompanyCardAdded: companyCard => {
          dispatch(this.addCompanyCard(companyCard))
        },
        onCompanyCardUpdated: companyCard => {
          dispatch(this.updateCompanyCard(companyCard))
        },
        onCompanyCardRemoved: companyCard => {
          dispatch(this.deleteCompanyCard({ companyCardId: companyCard.id }))
        },
      })
      return response
    },
  )
  addCompanyCard = createAction('companyCards/addCompanyCard', (companyCard: CompanyCard) => ({
    payload: companyCard,
  }))
  updateCompanyCard = createAction(
    'companyCards/updateCompanyCard',
    (companyCard: CompanyCard) => ({
      payload: companyCard,
    }),
  )
  deleteCompanyCard = createAction(
    'companyCards/deleteCompanyCard',
    ({ companyCardId }: { companyCardId: string }) => ({
      payload: { companyCardId },
    }),
  )
}

export default new CompanyCardsActions()
